import { useAuth } from "../../context/auth-context";
import type {
  AdminOtcTransactionSummariesData,
  AdminOtcTransactionSummariesEnvelope,
} from "./adminOtcTransactionSummaries";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export type UseAdminOtcTransactionSummariesParams = {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
};

/**
 * GET api/admin/transactions/summaries?type=otc[&startDate][&endDate]
 *
 * Deliberately unfiltered by subtype: this endpoint rejects `otcSubtypes`
 * ("otcSubtypes is not allowed"), so the summary always covers both sides.
 */
export function useAdminOtcTransactionSummariesQuery(
  params: UseAdminOtcTransactionSummariesParams = {}
) {
  const { isAuthenticated } = useAuth();
  const { startDate, endDate, enabled: enabledParam = true } = params;

  return useApiQuery<
    AdminOtcTransactionSummariesEnvelope,
    AdminOtcTransactionSummariesData
  >({
    queryKey: apiQueryKey("admin-transactions-summaries", {
      type: "otc",
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/summaries",
    params: {
      type: "otc",
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
